import React from 'react'

function SectionTitle({children}) {
  return (
    <h2 className="text-2xl/7 font-semibold mb-1.5">{children}</h2>
  )
}

export default SectionTitle